<template>
    <div class="login-container">
        <div class="login-box">
            <h3 v-if="checkIsTopShow" class="title">观致汽车 经销商门户系统</h3>
            <!-- <h3 v-if="true" class="title">观致汽车  经销商门户系统</h3> -->
            <h3 v-else class="title">观致系统</h3>
            <div class="login-form">
                <el-form :model="loginForm" :rules="loginRules" ref="ruleLoginForm" class="login-ruleForm">
                    <el-form-item prop="username">
                        <el-input v-model="loginForm.username" placeholder="用户名" prefix-icon="el-icon-user" @keyup.enter.native="submitLoginForm()" autocomplete="off"></el-input>
                    </el-form-item>
                    <el-form-item prop="password">
                        <el-input type="password" v-model="loginForm.password" placeholder="密码" prefix-icon="el-icon-lock" @keyup.enter.native="submitLoginForm()" autocomplete="off" show-password ></el-input>

                    </el-form-item>
                    <div class="pw-box">
                        <div class="remember">
                            <el-checkbox v-model="remember" @change="handleIsRemember">记住密码</el-checkbox>
                        </div>
                    </div>
                    <el-form-item>
                            <el-button class="login-button" type="primary" @keyup.enter.native="submitLoginForm()" @click="submitLoginForm()">登 录
                            </el-button>
                    </el-form-item>
                </el-form>
                <!-- <div v-if="true" class="reset-register"> -->
                <div v-if="checkIsTopShow" class="reset-register">
                    <el-button type="text" @click="goReset">忘记密码</el-button>
                    <el-button type="text" @click="goRegister">注 册</el-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import apiDataFilter from "../utils/apiDataFilter";
import {localSave,checkIsDealer,checkIsTopShow} from "@/utils/tools";
import Cookies from 'js-cookie';
import { mapState, mapActions } from 'vuex'
import queryString from 'query-string'
import config from '../config/system'

export default {
    name: "login",
    data() {
        return {
            loginForm: {
                username: '',
                password: '',
                auth_type: checkIsDealer() ? 'dp' : 'ldap',
                scope: 'all',
                grant_type: 'password',
                domain: 'tenant',
                user_domain: 'qoros'
            },
            loginRules: {
                username: [{ required: true, message: '请输入用户名', trigger: 'blur' },],
                password: [{ required: true, message: '请输入密码', trigger: 'blur' }]
            },
            remember: false,
            parsedData:null,
            newToken:null,
            checkIsTopShow:checkIsTopShow()
        }
    },
    created() {
        const {token} = this.$route.query
        const {callback} = this.$route.query
        if (token) {
          Cookies.set('admin-token', token.split(" ")[1]);
          console.log("_______________" , callback)
          if(callback){
            console.log("jumpTo----------------" , callback)
            window.location.href = callback
          }else {
            console.log("reload----------------" , callback)
            window.location.reload()
          }

        }
    },
    methods: {
        ...mapActions({
            SetRoles: 'SetRoles'
        }),

        submitLoginForm() {
            apiDataFilter.removeCookies();
            this.$refs.ruleLoginForm.validate((valid) => {
                if (valid) {
                    if (this.checkSource()[config.clientId]) {
                        this.getNewLogin()
                    } else {
                        Promise.all([
                            this.getTokenNew(),
                        ]).then(() => {
                            let parsedData = this.checkSource()
                            if (parsedData && parsedData[config.redirectUrl]) {
                                let params = {
                                    token: this.newToken
                                }
                                const stringified = queryString.stringify(params);
                                window.location.href = `${decodeURIComponent(parsedData[config.redirectUrl])}?${stringified}`
                            } else {
                                this.$router.push('/')
                            }
                        })
                    }
                }
            })
        },

        getNewLogin() {
            let name = this.loginForm.username //'qoros'+'\\'+this.loginForm.username
            let parsedData = this.checkSource()
            let param = Object.assign({}, this.loginForm, {username: name,
                auth_type: this.checkSource()[config.clientId] ? 'code': checkIsDealer() ? 'password':'ldap',
                user_domain: checkIsDealer() ? 'dealer':'qoros',
                client_id: parsedData.client_id,
                redirect_uri: parsedData.redirect_uri,
                response_type: parsedData.response_type})
            return apiDataFilter.request({
                api: 'login.newLogin',
                method: 'post',
                params: param
            }).then((res) => {

            })
        },

        /*新的 token*/
        getTokenNew() {
            let name = this.loginForm.username //'qoros'+'\\'+this.loginForm.username
            let param = Object.assign({}, this.loginForm, { username: name, auth_type: checkIsDealer() ? 'password' : 'ldap', user_domain: checkIsDealer() ? 'dealer' : 'qoros' })
            return apiDataFilter.request({
                api: 'login.token',
                method: 'post',
                params: param
            }).then((res) => {
                let result = res.data
                this.newToken = `${result.token_type} ${result.access_token}`
                if (this.checkSource()[config.redirectUrl]) return
                Cookies.set('admin-token', result.access_token);
            })
        },
        /*旧的token*/
        getTokenOld() {
            let name = checkIsDealer() ? this.loginForm.username : 'qoros' + '\\' + this.loginForm.username
            let param = Object.assign({}, this.loginForm, { username: name })
            return apiDataFilter.request({
                api: 'login.tokenOld',
                method: 'post',
                params: param
            }).then((res) => {
                let result = res.data
                if (this.checkSource()[config.redirectUrl]) return
                this.$ls.set('token', `${result.token_type} ${result.access_token}`)
            })
        },
        handleIsRemember(val) {
            if (val) {

            }
        },
        checkSource(){
             return  queryString.parse(location.search) || null
        },
        goReset(){
            this.$router.push("/reset");
        },
        goRegister(){
            this.$router.push("/register");
        }
    }

}
</script>

<style scoped lang="less">
@import "../style/variables.less";

.login-container {
    position: fixed;
    width: 100%;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 1;
    background: url("../img/qgws1.png") center/cover no-repeat;

    .login-box {
        position: absolute;
        top: 10%;
        left: 63%;
        width: 32%;

        .title {
            font-size: 40px;
            font-weight: 500;
            color: #333;
        }

        .login-form {
            margin-top: 60px;

            .el-form-item:not(:last-child) {
                margin-top: 60px;
            }

            .el-input {
                //border-bottom: 1px solid #ccc;

                /deep/ .el-input__inner {
                    border: none;
                    background-color: inherit;
                    padding-left: 40px;

                    &::placeholder {
                        font-size: 16px;
                        color: #666;
                        font-weight: 400;
                    }
                }

                /deep/ .el-input__icon {
                    font-size: 18px;
                    color: #666;
                }
            }

            .remember {
                margin-top: 20px;

                .el-checkbox {
                    /deep/ .el-checkbox__input {
                        vertical-align: baseline !important;

                        .el-checkbox__inner {
                            background-color: inherit;
                        }

                        &.is-checked {
                            .el-checkbox__inner {
                                background-color: @theme-color;
                            }
                        }
                    }
                }
            }

            .el-button {
                width: 80%;
                margin: 0 auto;
                display: block;
                margin-top: 40px;
            }

            .reset-register {
                display: flex;
                justify-content: space-around;
            }
        }
    }
}

</style>